import React from "react";
import { Button } from "./ui/button";

export const PaginationBar = ({ page, total, perPage, onPageChange, loading, label, search, testIdPrefix }) => {
  const lastPage = Math.max(1, Math.ceil(total / perPage));
  const btn = (text, target, disabled, id) => (
    <Button variant="outline" size="sm" onClick={() => onPageChange(target)} disabled={disabled || loading} data-testid={`${testIdPrefix}-${id}`}>
      {text}
    </Button>
  );
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-4 px-2" data-testid={testIdPrefix}>
      <div className="text-sm text-gray-600" data-testid={`${testIdPrefix}-summary`}>
        <span className="font-medium">{total === 0 ? 0 : (page - 1) * perPage + 1} - {Math.min(page * perPage, total)}</span>
        {" / "}<span className="font-bold">{total}</span> {label}
        {search && <span className="ml-2 text-blue-600">("{search}" araması)</span>}
      </div>
      {total > perPage && (
        <div className="flex items-center gap-2">
          {btn("« İlk", 1, page === 1, "first")}
          {btn("‹ Önceki", page - 1, page === 1, "prev")}
          <span className="text-sm px-3 py-1 bg-gray-100 rounded font-medium" data-testid={`${testIdPrefix}-info`}>
            Sayfa {page} / {lastPage}
          </span>
          {btn("Sonraki ›", page + 1, page >= lastPage, "next")}
          {btn("Son »", lastPage, page >= lastPage, "last")}
        </div>
      )}
    </div>
  );
};
